import { FC } from 'react';
import Dialog from 'components/common/Dialog/Dialog';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import ELEMENT from 'common/element';

type LinkAccountModalProps = {
  showModal: boolean;
  handleShowModal: () => void;
  modalMessage: string;
};

export const LinkAccountModal: FC<LinkAccountModalProps> = ({
  showModal,
  modalMessage,
  handleShowModal,
}: LinkAccountModalProps) => {
  const footerConfig = {
    rightItems: [
      <Button variant={ButtonVariant.PRIMARY} onClick={handleShowModal} testId={ELEMENT.linkAccountPageModalOkButton}>
        OK
      </Button>,
    ],
  };
  return (
    <Dialog
      show={showModal}
      close={handleShowModal}
      footer={footerConfig}
      title="Link Account"
      size="lg"
      testId={ELEMENT.linkAccountPageModal}
    >
      {modalMessage}
    </Dialog>
  );
};
